import { createApiClient } from './apiClient';
import { config } from '../config';

const apiClient = createApiClient({
    baseURL: `${config.bffUrl}/api/`,
});

export const sendLifecycleEvent = async (payload) => {
    const response = await apiClient.post('lifecycle-events', payload);
    return response.data;
};
